import React from 'react';

import { Breadcrumbs, Link, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  navRoot: {
    marginBottom: theme.spacing(2),
    padding: theme.spacing(0.5, 2),
    backgroundColor: '#fff',
    border: '1px solid #eaeef1',
    borderRadius: '4px',
  },
}));

const UsersNav = ({ pathname }) => {
  const classes = useStyles();

  const renderNav = () => {
    switch (pathname) {
      case '/admin/users':
        return <Typography color='text.primary'>Member Accounts</Typography>;
      case '/admin/courses':
        return <Typography color='text.primary'>Courses</Typography>;
      default:
        return (
          <Link underline='hover' color='inherit' href='/admin/users'>
            Member Accounts
          </Link>
        );
    }
  };

  return (
    <div className={classes.navRoot}>
      <Breadcrumbs aria-label='breadcrumb'>
        <Link underline='hover' color='inherit' href='/admin'>
          Main Menu
        </Link>
        {renderNav()}
      </Breadcrumbs>
    </div>
  );
};

export default UsersNav;
